import React from 'react';
import { NavLink } from 'react-router-dom';

interface NavItem {
  label: string;
  to: string;
}

interface NavGroup {
  group: string;
  items: NavItem[];
}

const NAV: NavGroup[] = [
  {
    group: 'Observe',
    items: [
      { label: 'Dashboard', to: '/dashboard' },
      { label: 'Users', to: '/users' },
      { label: 'Runs', to: '/runs' },
      { label: 'Findings', to: '/findings' },
      { label: 'Unknown ATSes', to: '/improvements/unknown-ats' },
      { label: 'Waitlist', to: '/waitlist' },
    ],
  },
  {
    group: 'Act',
    items: [
      { label: 'Triage Sessions', to: '/triage-sessions' },
    ],
  },
  {
    group: 'Govern',
    items: [
      { label: 'Audit Log', to: '/audit' },
      { label: 'Settings', to: '/settings' },
    ],
  },
];

export function Sidebar(): React.ReactElement {
  return (
    <nav
      className="w-56 shrink-0 bg-surface border-r border-border flex flex-col py-4"
      aria-label="Primary navigation"
    >
      <div className="px-4 mb-6">
        <span className="text-lg font-bold text-brand-700">OutLinked</span>
        <span className="ml-1 text-xs text-text-muted">Admin</span>
      </div>
      <div className="flex-1 space-y-4 overflow-y-auto">
        {NAV.map(({ group, items }) => (
          <div key={group}>
            <p className="px-4 mb-1 text-xs font-semibold uppercase tracking-wide text-text-muted">
              {group}
            </p>
            <ul role="list">
              {items.map(({ label, to }) => (
                <li key={to}>
                  <NavLink
                    to={to}
                    className={({ isActive }) =>
                      [
                        'flex items-center px-4 py-2 text-sm rounded-none transition-colors',
                        isActive
                          ? 'bg-brand-50 text-brand-700 font-medium border-r-2 border-brand-600'
                          : 'text-text-secondary hover:bg-surface-muted hover:text-text-primary',
                      ].join(' ')
                    }
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </nav>
  );
}
